/* eslint-disable consistent-return, array-callback-return */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import querystring from 'query-string';
import { isEmpty } from 'lodash';
import VerbHeading from '../../../../shared/components/VerbHeading';
import Image from '../../../../shared/components/Image';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import { DEFAULT_IMAGE_URLS } from '../../../../shared/Constants';

export default class PathwayDetails extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    static propTypes = {
        pathway: PropTypes.object,
        collectionsById: PropTypes.object,
        selectPathway: PropTypes.func,
        isMobile: PropTypes.bool,
        onClickBack: PropTypes.func,
        openPathwayDetails: PropTypes.func
    };

    componentDidMount() {
        const { pathway, openPathwayDetails } = this.props;
        if (isEmpty(pathway)) {
            const { pathwayId = '' } = querystring.parse(window.location.search);
            if (pathwayId) {
                openPathwayDetails(pathwayId);
            }
        }
    }

    _createRows = () => {
        const { pathway, collectionsById, isMobile } = this.props;
        return (pathway?.content || []).map((milestone, idx) => {
            let collection;
            let primaryDetail = null;
            let secondaryDetail = null;
            let iconImage = (
                <Image
                    src={DEFAULT_IMAGE_URLS.PATHWAY_EVENT_FLAG}
                    className={'pathway-event-flag'}
                    dimension={{ h: 43, w: 45 }}
                    cloudinaryCrop={'fill'}
                    quality={{ q: 100 }}
                />
            );
            if (milestone.id) {
                // find collection by id
                collection = collectionsById[milestone.id];
                if (collection) {
                    if (
                        (collection.durationInMinutes || collection.totalTimeForCollection) &&
                        !collection.memberCount
                    ) {
                        const collectionTime = collection.durationInMinutes || collection.totalTimeForCollection;
                        const collectionText =
                            collectionTime < 60 ? `${collectionTime} MINS` : `${Math.round(collectionTime / 60)} HRS`;
                        primaryDetail = (
                            <div className={'col-6 collection-time'}>
                                <i className={'fal fa-clock meta-icon-size meta-vertical-align'} />
                                <span className={'meta-vertical-align meta-space'}>{collectionText}</span>
                            </div>
                        );
                    }
                    if (collection.content || collection.contentIds) {
                        const collectionCount = collection.content
                            ? collection.content.length
                            : collection.contentIds.length;
                        secondaryDetail = (
                            <div className={'col-6 collection-activities'}>
                                <i className={'fal fa-book meta-icon-size meta-vertical-align book-icon'} />
                                <span className={'meta-vertical-align meta-space'}>{collectionCount} ACTIVITIES</span>
                            </div>
                        );
                    }
                    iconImage =
                        idx > 0 ? (
                            <Image
                                src={DEFAULT_IMAGE_URLS.LEARNING_PATHWAY_FLAG}
                                className={'herbie-flag'}
                                cloudinaryCrop={'fill'}
                                quality={{ q: 100 }}
                            />
                        ) : (
                            <Image
                                src={DEFAULT_IMAGE_URLS.LEARNING_PATHWAY_HERBIE_FLAG}
                                className={'herbie-holding-flag'}
                                dimension={{ h: 73, w: 75 }}
                                cloudinaryCrop={'fill'}
                                quality={{ q: 100 }}
                            />
                        );
                }
            }

            const eventThumbnails = [
                DEFAULT_IMAGE_URLS.PATHWAY_EVENT_THUMBNAIL_GREY,
                DEFAULT_IMAGE_URLS.PATHWAY_EVENT_THUMBNAIL
            ];
            const randomNum = Math.floor(Math.random() * 2) + 1;

            if (
                collection ||
                (milestone.name && milestone.shortDescription && milestone.type === 'EVENT') ||
                milestone.type === 'TASK'
            ) {
                let milestoneDateTime;
                let cardImage = eventThumbnails[randomNum - 1];
                let cardTitle = milestone.name;
                let cardSubtitle = milestone.shortDescription;

                if (collection) {
                    cardImage = collection.thumbnailImageUrl;
                    cardTitle = collection.name;
                    cardSubtitle = collection.subtitle;
                } else if (milestone.type === 'TASK') {
                    cardImage = DEFAULT_IMAGE_URLS.PATHWAY_TASK_THUMBNAIL;

                    iconImage = (
                        <Image
                            src={DEFAULT_IMAGE_URLS.PATHWAY_TASK_INCOMPLETE}
                            className={'pathway-event-flag'}
                            dimension={{ h: 48, w: 48 }}
                            cloudinaryCrop={'fill'}
                            quality={{ q: 100 }}
                        />
                    );

                    if (milestone.dateTime) {
                        const formattedDateTime = moment(milestone.dateTime).utc().format('M/D');
                        milestoneDateTime = (
                            <div className={'col-6 milestone-date'}>
                                <i className={'fal fa-calendar-alt meta-icon-size meta-vertical-align'} />
                                <span className={'meta-vertical-align meta-space'}>
                                    DUE {formattedDateTime.toUpperCase()}
                                </span>
                            </div>
                        );
                    }
                } else if (milestone.dateTime) {
                    const formattedDateTime = moment(milestone.dateTime).utc().format('M/D @h:mma');
                    milestoneDateTime = (
                        <div className={'col-6 milestone-date'}>
                            <i className={'fal fa-calendar-alt meta-icon-size meta-vertical-align'} />
                            <span className={'meta-vertical-align meta-space'}>{formattedDateTime.toUpperCase()}</span>
                        </div>
                    );
                }
                return (
                    <div
                        className={'col-12 milestone-row'}
                        key={milestone.id || `${milestone.name} ${milestone.type} ${milestone.shortDescription}`}
                    >
                        <div className={'row collection-list-row'}>
                            <div className={`row-icon col-1 ${idx === 0 ? 'first-row' : ''}`}>
                                {idx > 0 ? <div className={'event-border above'} /> : null}
                                {iconImage}
                                <div className={'event-border below'} />
                            </div>
                            <div className={`${isMobile ? 'col-9' : 'col-10'} offset-sm-1 collection-info`}>
                                <div className={'row milestone-info-row'}>
                                    <div className={isMobile ? 'col-12' : 'col-4 milestone-thumbnail'}>
                                        {milestone.name &&
                                        milestone.shortDescription &&
                                        milestone.type !== 'COLLECTION' ? (
                                            <div className={'milestone-asset-thumbnail'}>
                                                <Image
                                                    src={cardImage}
                                                    className={'asset-thumbnail'}
                                                    dimension={isMobile ? { h: 75, w: 75 } : { h: 150, w: 150 }}
                                                    cloudinaryCrop={'fill'}
                                                    quality={{ q: 100 }}
                                                    effect={'grayscale'}
                                                />
                                            </div>
                                        ) : (
                                            <Image
                                                src={cardImage}
                                                className={'asset-thumbnail'}
                                                dimension={isMobile ? { h: 75, w: 75 } : { h: 150, w: 150 }}
                                                cloudinaryCrop={'fill'}
                                                quality={{ q: 100 }}
                                                effect={'grayscale'}
                                            />
                                        )}
                                    </div>
                                    <div className={`collection-list-row-details ${isMobile ? 'col-12' : 'col-8'}`}>
                                        <div className={'row collection-list-row-name'}>
                                            <VerbHeading defaultMessage={cardTitle} hNumber={3} />
                                        </div>
                                        <div
                                            className={`row collection-list-row-subtitle ${
                                                cardTitle && cardTitle.length <= 60 ? 'long-subtitle' : 'short-subtitle'
                                            }`}
                                        >
                                            {cardSubtitle}
                                        </div>
                                        <div className={'row collection-list-row-activities align-items-end'}>
                                            {milestoneDateTime}
                                            {primaryDetail}
                                            {secondaryDetail}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        });
    };

    render() {
        const { pathway = {}, selectPathway, isMobile, onClickBack } = this.props;
        const milestones = this._createRows();

        return (
            <div className={isMobile ? 'mobile-pathway-detail-container' : 'pathway-detail-container'}>
                {isMobile ? (
                    <div className={'title-row'}>
                        <VerbButton
                            className={'pathway-back-arrow'}
                            fontAwesomeIcon={'fa-chevron-left'}
                            onClick={() => onClickBack('browse')}
                        />
                        <VerbHeading
                            messageId={'CHOOSE_PATHWAY'}
                            defaultMessage={'Choose a Pathway'}
                            className={'choose-pathway-title'}
                            hNumber={3}
                        />
                    </div>
                ) : (
                    <div className={'row justify-content-between align-items-center'}>
                        <VerbHeading
                            messageId={'CHOOSE_PATHWAY'}
                            defaultMessage={'Choose a Pathway'}
                            className={'col-12 col-md-7 choose-pathway-title'}
                            hNumber={3}
                        />
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            fontAwesomeIcon={'fa-chevron-left'}
                            className={'col-2 pathway-back-arrow'}
                            onClick={() => onClickBack('browse')}
                            buttonText={'BACK'}
                        />
                    </div>
                )}
                <div className={'row detail-container'}>
                    <div className={'row details-collection-details'}>
                        <div className={'col-lg-7 col-md-6 col-12 details-left'}>
                            <div className={'row'}>
                                <div className={'col-12 path-name'}>{pathway.name}</div>
                                <div className={'col-12 objectives'}>
                                    <div className={'col-12 objective-header'}>
                                        By the end of this pathway you will be able to...
                                    </div>
                                    <ul className={'objective-list'}>
                                        {(pathway?.objectives || []).map((objective) => (
                                            <li key={objective}>{objective}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className={'d-none d-md-block d-lg-block d-xl-block col-1 border-line'}>
                            <div className={'detail-border'} />
                        </div>
                        <div className={'row col-lg-3 col-md-3 col-12 details-right'}>
                            <div className={'row recommended-pace'}>Recommended Pace:</div>
                            <ul className={'pace-detail col-12'}>
                                <li>{pathway.pace}</li>
                            </ul>
                            {pathway.bestFor && pathway.bestFor.length ? (
                                <>
                                    <div className={'row best-for'}>Best for those who are:</div>
                                    <ul className={'best-for-list col-12'}>
                                        {pathway.bestFor.map((position) => (
                                            <li key={position}>{position}</li>
                                        ))}
                                    </ul>
                                </>
                            ) : null}
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                                onClick={() => selectPathway(pathway._id, pathway.name)}
                                className={'select-path-button'}
                            >
                                SELECT PATHWAY
                            </VerbButton>
                        </div>
                    </div>
                </div>
                <div className={'collection-list'}>{milestones}</div>
            </div>
        );
    }
}
